import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { StudyCard } from '.';
import { useParticipantDataStore } from '../../../../../../store';
import { Banner } from '../../../../../../component';
import { useTranslation } from 'react-i18next';

export const StudyCardWrapper = observer(() => {
  const participantDataStore = useParticipantDataStore();
  const { horizon0 } = participantDataStore.bagSurvey;
  const horizon1BannerLink = participantDataStore.horizon1BannerLink;
  const { t } = useTranslation('profilescreen');

  useEffect(() => {
    participantDataStore.getBagSurveyStatus();
  }, [participantDataStore]);

  if (!horizon0?.surveyLink)
    return (
      <Banner
        padding="0px"
        margin="0px"
        title={t('StudyCard.BannerTitle')}
        description={t('StudyCard.BannerDescription')}
      />
    );

  if (!horizon0.filledOut) {
    return (
      <Banner
        padding="0px"
        margin="0px"
        title={'Du hast einen offenen Fragebogen!'}
        description={
          'Du musst erst den folgenden Fragebogen ausfüllen bevor du deinen Studienausweis erhalten kannst.'
        }
        link={horizon0.surveyLink}
      />
    );
  }

  return (
    <>
      <StudyCard />
      {horizon1BannerLink && (
        <Banner
          padding="0px"
          margin="0px"
          title={'Du hast einen offenen Folgefragebogen!'}
          description={
            'Bitte füllen Sie den folgenden BAG-Fragebogen aus (zweite Online-Umfrage).'
          }
          link={horizon1BannerLink}
        />
      )}
    </>
  );
});
